import { render, staticRenderFns } from "./medical_detail.vue?vue&type=template&id=7291ad9c"
import script from "./medical_detail.vue?vue&type=script&lang=js"
export * from "./medical_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports